module.exports = __webpack_public_path__ + "static/media/ic_add-file-primary.ff2c661c.svg";